import { useLanguage } from "@/lib/LanguageContext";
import { Instagram } from "lucide-react";
import { WhatsAppIcon } from "@/components/icons/WhatsAppIcon";

export default function Footer() {
  const { t } = useLanguage();
  return (
    <footer
      data-testid="site-footer"
      className="relative px-6 sm:px-12 lg:px-24 pt-24 pb-10 bg-[#0B0C10] overflow-hidden"
    >
      <div className="max-w-[1600px] mx-auto">
        <h2
          data-testid="footer-headline"
          className="font-display font-black text-white tracking-tighter leading-[0.9]"
          style={{ fontSize: "clamp(2.5rem, 12vw, 10rem)" }}
        >
          <span className="block">{t.footer.headline_l1}</span>
          <span className="block">
            {t.footer.headline_l2}
            <span className="text-[#D97736]">.</span>
          </span>
        </h2>

        <div className="mt-24 grid grid-cols-2 md:grid-cols-4 gap-8 border-t border-white/10 pt-12">
          <div>
            <div className="text-xs uppercase tracking-widest text-[#A0AAB2] mb-3">
              Workshop
            </div>
            <a
              data-testid="footer-address-link"
              href="https://maps.google.de/maps?q=Buchstauden+16%2C+78269+Volkertshausen"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white text-sm leading-relaxed hover:text-[#D97736] transition-colors block"
            >
              Buchstauden 16
              <br />
              78269 Volkertshausen
              <br />
              <span className="text-[#A0AAB2]">
                bei Singen / Konstanz / Schaffhausen
                <br />
                Grenzübergang Thayngen
                <br />
                südliches Ende der Autobahn A81
              </span>
            </a>
          </div>
          <div>
            <div className="text-xs uppercase tracking-widest text-[#A0AAB2] mb-3">
              Hours
            </div>
            <div className="text-white text-sm">{t.footer.hours}</div>
          </div>
          <div>
            <div className="text-xs uppercase tracking-widest text-[#A0AAB2] mb-3">
              Contact
            </div>
            <a
              href="mailto:post@schneggundweg.de"
              className="block text-white text-sm hover:text-[#D97736] transition-colors"
            >
              post@schneggundweg.de
            </a>
            <a
              href="tel:+4977315071668"
              className="block text-white text-sm hover:text-[#D97736] transition-colors mt-1"
            >
              +49 7731 5071668
            </a>
          </div>
          <div>
            <div className="text-xs uppercase tracking-widest text-[#A0AAB2] mb-3">
              Social
            </div>
            <div className="flex gap-3">
              <a
                data-testid="footer-social-instagram"
                href="https://instagram.com/schnegg.und.weg"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram @schnegg.und.weg"
                className="inline-flex items-center gap-2 px-3 h-10 border border-white/15 text-white hover:bg-[#D97736] hover:border-[#D97736] transition-colors"
              >
                <Instagram className="w-4 h-4" />
                <span className="text-xs font-medium tracking-wide">@schnegg.und.weg</span>
              </a>
              <a
                data-testid="footer-social-whatsapp"
                href="https://wa.me/4917680413791"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp Chat"
                className="inline-flex items-center gap-2 px-3 h-10 border border-white/15 text-white hover:bg-[#D97736] hover:border-[#D97736] transition-colors"
              >
                <WhatsAppIcon className="w-4 h-4" />
                <span className="text-xs font-medium tracking-wide">WhatsApp</span>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs uppercase tracking-widest text-[#A0AAB2]">
          <div>© {new Date().getFullYear()} schnegg.<span className="text-[#D97736]">.</span> und weg! {t.footer.rights}</div>
          <div className="flex items-center gap-5">
            <a
              data-testid="footer-impressum-link"
              href="/impressum.html"
              className="hover:text-white transition-colors"
            >
              Impressum
            </a>
            <a
              data-testid="footer-datenschutz-link"
              href="/datenschutz.html"
              className="hover:text-white transition-colors"
            >
              Datenschutz
            </a>
            {t.footer.built && <span>{t.footer.built}</span>}
          </div>
        </div>
      </div>
    </footer>
  );
}
